var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbBookBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1334,
    height: 936,
    viewBox: "0 0 1334 936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1350",
    x: 10,
    y: 35,
    width: 1323,
    height: 901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1349",
    x: 10,
    y: 18,
    width: 1323,
    height: 902,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1348",
    x: 0,
    y: 0,
    width: 1323,
    height: 901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-bkg-index",
    x1: 0.324,
    y1: 0.35,
    x2: 1.992,
    y2: 0.562,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeeeee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIVRE_SUPPORT",
    "data-name": "LIVRE SUPPORT",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1346",
    "data-name": "Rectangle 1346",
    d: "M141,0H1251a72,72,0,0,1,72,72V823a72,72,0,0,1-72,72H72A72,72,0,0,1,0,823V141A141,141,0,0,1,141,0Z",
    transform: "translate(2 32)",
    fill: "#28507d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_1350)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1350-2",
    "data-name": "Rectangle 1350",
    width: 1305,
    height: 883,
    rx: 72,
    transform: "translate(19 41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8562",
    "data-name": "Trac\\xE9 8562",
    d: "M17.337,0c9.575,0,17.337,17.337,17.337,17.337H0S7.762,0,17.337,0Z",
    transform: "translate(635.561 902.363)",
    fill: "#22456c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_1349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1349-2",
    "data-name": "Rectangle 1349",
    width: 1305,
    height: 884,
    rx: 72,
    transform: "translate(19 24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_1348)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1348-2",
    "data-name": "Rectangle 1348",
    width: 1305,
    height: 883,
    rx: 72,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1345",
    "data-name": "Rectangle 1345",
    d: "M72,0H653a0,0,0,0,1,0,0V883a0,0,0,0,1,0,0H72A72,72,0,0,1,0,811V72A72,72,0,0,1,72,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-bkg-index)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbBookBackground);
export default __webpack_public_path__ + "static/media/ib-book-background.95bd8123.svg";
export { ForwardRef as ReactComponent };